import { BlockchainSports } from "../models/blockchainsports/BlockchainSports";
import { responseHero } from "../utils/axiosInterceptor";

export const getBlockchainSport = (groupId: number): Promise<BlockchainSports[]> => {
    return new Promise<BlockchainSports[]>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/blockchainsports/${groupId}`).then((response) => {
            resolve(response.data as BlockchainSports[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};